import React, { useState } from 'react';
import styled from 'styled-components';
import { Settings, ChevronDown, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProfileContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ProfileButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  color: #333;

  &:hover {
    background: #f8f9fa;
    border-color: #2e7d32;
  }
`;

const ProfileAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #2e7d32;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 0.8rem;
`;

const ProfileName = styled.span`
  font-weight: 500;
  color: #333;
`;

const DropdownMenu = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 1000;
  display: ${props => props.isOpen ? 'block' : 'none'};
  margin-top: 4px;
`;

const DropdownItem = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.9rem;
  color: #333;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }

  &:only-child {
    border-radius: 8px;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: #e0e0e0;
  margin: 4px 0;
`;

const TopRightProfile: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleProfileClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleFarmProfileClick = () => {
    navigate('/farm-profile');
    setIsDropdownOpen(false);
  };

  const handleLogoutClick = () => {
    // Handle logout logic here
    setIsDropdownOpen(false);
  };

  // Get farm name from localStorage or use default
  const farmProfile = JSON.parse(localStorage.getItem('farm-profile-data') || '{}');
  const farmName = farmProfile.farmName || 'Farm';
  const initials = farmName.split(' ').map((word: string) => word[0]).join('').toUpperCase().slice(0, 2);

  return (
    <ProfileContainer>
      <ProfileButton onClick={handleProfileClick}>
        <ProfileAvatar>
          {initials}
        </ProfileAvatar>
        <ProfileName>{farmName}</ProfileName>
        <ChevronDown size={16} />
      </ProfileButton>

      <DropdownMenu isOpen={isDropdownOpen}>
        <DropdownItem onClick={handleFarmProfileClick}>
          <Settings size={16} />
          Farm Profile
        </DropdownItem>
        <Divider />
        <DropdownItem onClick={handleLogoutClick}>
          <LogOut size={16} />
          Logout
        </DropdownItem>
      </DropdownMenu>
    </ProfileContainer>
  );
};

export default TopRightProfile;
